import { useContext } from "react";

import { SwipperContext } from "components/Swipper";
import { useApi } from "hooks/useApi";
import { ApiEndpoint, baseFetcher } from "utils/baseFetcher";

import DashboardPageSuggestedEntitiesSnippet from "./DashboardPageSuggestedEntitiesSnippet";

export const suggestedEntitiesUrl = () => {
  const url = new ApiEndpoint(`/api/v2/suggested-entities`);
  url.searchParams.append("page[size]", "12");
  url.searchParams.append("page[number]", "1");

  return url.href;
};

const DashboardPageSuggestedEntities = () => {
  const { setEnabledSwipe } = useContext(SwipperContext);

  const { data: entities } = useApi(suggestedEntitiesUrl(), baseFetcher);

  if (!entities?.data?.length) return <></>;

  return (
    <div className="flex flex-col border-b-[1px] border-x-0 border-t-0 border-b-[#00000022] border-solid">
      <h1 className="text-base m-[15px] mb-0">Suggested Entities</h1>
      <div
        className="flex overflow-x-auto p-[15px] gap-[10px]"
        onScroll={() => {
          setEnabledSwipe?.(false);
        }}
      >
        {entities?.data?.map((entity: any) => {
          return (
            <DashboardPageSuggestedEntitiesSnippet
              key={entity.id}
              entity={entity}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DashboardPageSuggestedEntities;
